export function deletetag(input: string | undefined, allow: string[]) {
  let regExp;

  if (allow.length !== 0)
    regExp = "<\\/?(?!(" + allow.join("|") + "))\\b[^>]*>";
  else regExp = "<[^>]*>";

  let result = input?.replace(new RegExp(regExp, "gi"), "");

  const replacements = {
    "&nbsp;": " ",
    "&bull;": ":",
    "&#39;": "'",
    "&quot;": " ",
    "&agrave;": "à",
    "&ecirc;": "ê",
    "&iexcl;": "¡",
    "&aacute;": "á",
    "&ccedil;": "ç",
    "&Ccedil;": "Ç",
    "&atilde;": "ã",
    "&Atilde;": "Ã",
    "&Eacute;": "É",
    "&eacute;": "é",
    "&Agrave;": "À",
    "&Aacute;": "Á",
    "&Acirc;": "Â",
    "&Auml;": "Ä",
    "&Aring;": "Å",
    "&egrave;": "è",
    "&Egrave;": "È",
    "&Ecirc;": "Ê",
    "&Euml;": "Ë",
    "&Igrave;": "Ì",
    "&Iacute;": "Í",
    "&Icirc;": "Î",
    "&Iuml;": "Ï",
    "&igrave;": "ì",
    "&iacute;": "í",
    "&icirc;": "î",
    "&iuml;": "ï",
    "&Ntilde;": "Ñ",
    "&ntilde;": "ñ",
    "&Ograve;": "Ò",
    "&Oacute;": "Ó",
    "&Ocirc;": "Ô",
    "&Otilde;": "Õ",
    "&Ouml;": "Ö",
    "&ograve;": "ò",
    "&oacute;": "ó",
    "&ocirc;": "ô",
    "&otilde;": "õ",
    "&ouml;": "ö",
    "&Oslash;": "Ø",
    "&oslash;": "ø",
    "&#140;": "Œ",
    "&#156;": "œ",
    "&#138;": "Š",
    "&#154;": "š",
    "&Ugrave;": "Ù",
    "&Uacute;": "Ú",
    "&Ucirc;": "Û",
    "&Uuml;": "Ü",
    "&ugrave;": "ù",
    "&uacute;": "ú",
    "&ucirc;": "û",
    "&uuml;": "ü",
    "&#181;": "µ",
    "&#215;": "x",
    "&Yacute;": "Ý",
    "&#159;": "Ÿ",
    "&yacute;": "ý",
    "&yuml;": "ÿ",
    "&#176;": "°",
    "&#134;": "†",
    "&#135;": "‡",
    "&lt;": "<",
    "&gt;": ">",
    "&#177;": "±",
    "&#171;": "«",
    "&#187;": "»",
    "&#191;": "¿",
    "&#161;": "¡",
    "&#183;": "·",
    "&#149;": "•",
    "&#153;": "™",
    "&copy;": "©",
    "&reg;": "®",
    "&#167;": "§",
    "&#182;": "¶"
  };

  for (const [search, replace] of Object.entries(replacements)) {
    result = result?.replace(RegExp(search, "gi"), replace);
  }

  return result;
}
